module.exports = __webpack_public_path__ + "static/media/Checkbox.8c91fd67.svg";